import { render, staticRenderFns } from "./new-panorama-summary-table.vue?vue&type=template&id=590b229e&scoped=true"
import script from "./new-panorama-summary-table.vue?vue&type=script&lang=js"
export * from "./new-panorama-summary-table.vue?vue&type=script&lang=js"
import style0 from "./new-panorama-summary-table.vue?vue&type=style&index=0&id=590b229e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b229e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590b229e')) {
      api.createRecord('590b229e', component.options)
    } else {
      api.reload('590b229e', component.options)
    }
    module.hot.accept("./new-panorama-summary-table.vue?vue&type=template&id=590b229e&scoped=true", function () {
      api.rerender('590b229e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/new-panorama/components/new-panorama-summary-table.vue"
export default component.exports